/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailabilitiesBulkRetrievalResults } from '../../models/availabilities-bulk-retrieval-results';
import { AvailabilityBulkRetrievalRequest } from '../../models/availability-bulk-retrieval-request';

export interface StoresStoreIdCatalogEntryAvailabilitiesBulkRetrievePost$Params {
  storeId: string;
      body: AvailabilityBulkRetrievalRequest
}

export function storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost(http: HttpClient, rootUrl: string, params: StoresStoreIdCatalogEntryAvailabilitiesBulkRetrievePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AvailabilitiesBulkRetrievalResults>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost.PATH, 'post');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AvailabilitiesBulkRetrievalResults>;
    })
  );
}

storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost.PATH = '/stores/{storeId}/catalog-entry-availabilities/bulk-retrieve';
